import React from 'react';
import { useDispatch } from 'react-redux';
import { editorStyles } from 'shared/editor/PublishHelper';
import { updateChartCategoriesAction } from 'pages/ChartEditorPage/actions/chartEditor';
import CustomSelect, { customSelectColors, SelectItem } from 'shared/inputs/CustomSelect';
import { SeriesAssign } from 'shared/types/commonPropTypes';
import useCategoriesAndSeries from '../utils/useCategoriesAndSeries';

type CategoriesTabProps = {
  assignOption: SeriesAssign;
  setActiveColumns: (indexes: number[], series: number[]) => void;
  onMouseLeave: () => void;
  isMap: boolean;
  seriesAssignsIndex: number;
};

const CategoriesTab = (props: CategoriesTabProps) => {
  const dispatch = useDispatch();
  const { series, columns, categoriesLabels } = useCategoriesAndSeries(props.seriesAssignsIndex);

  const handleCategoriesChange = (selected: SelectItem | null) => {
    dispatch(updateChartCategoriesAction({ newCategories: selected?.value, newIndex: selected?.index }));
  };

  const onMouseEnter = (index: number) => () => props.setActiveColumns([index], [-1]);

  const options: SelectItem[] = columns.map((val, index) => {
    if (series.includes(val)) return { label: `Column ${val} - in use`, value: val, disabled: true, index };
    return { label: `Column ${val}`, value: val, index };
  });

  return (
    <>
      {Object.values(props.assignOption ?? {}).map((value: any, i) => {
        if (!value.isLabel || value.hidden) return null;

        return (
          <div
            key={`category_${i}`}
            onMouseEnter={onMouseEnter(categoriesLabels[value.name].index as number)}
            onMouseLeave={props.onMouseLeave}
          >
            <CustomSelect
              styles={editorStyles}
              backgroundColor={customSelectColors.grey}
              label={value.name ?? 'Categories'}
              labelClasses="text-base"
              options={options}
              value={categoriesLabels[value.name]}
              onChange={handleCategoriesChange}
              isDisabled={value.locked || props.isMap}
              isOptionDisabled={(value) => Boolean(value.disabled)}
            />
          </div>
        );
      })}
    </>
  );
};

export default CategoriesTab;
